// Browser polyfills
import 'whatwg-fetch';

// Libs
import React, { useState } from 'react';
import { Result, Layout } from 'antd';
import NackleMenu from '@nackle/menu';
const { Content, Sider } = Layout;

// Routing
import { Route, routeHistory } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './app-routing';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth, { authRouteMiddleware, authRequestMiddleware } from './app-auth';

// Fetch
import { applyRequestMiddleware } from './utils/fetch';

// Components
import { AppHeader, AppFooter, AppError } from '@nackle/studio-tools';

// Services
import { CMXService } from '@nackle/studio-tools';

// CMX
import { setLanguageBundle } from '@nackle/intl-tools';

// Styles
import './styles/app.less';

/*******************************************************************************
 *  1. App (root level component)
 */
export default function App() {
    
    const [ loaded, setLoaded ] = useState( false );
    const [ cmxBundleLoaded, setCmxBundleLoaded ] = useState( false );
    const [ locale, setLocale ] = useState();

    const handleSignIn = async () => {
        await routeHistory.refresh();

        const locale = auth.state.claims.locale;
        setLocale( locale );
        const cmxService = new CMXService( auth.state );
        const bundle = await cmxService.getBundle( [ 'studio-in-context-help', 'navigation' ], locale );
        setLanguageBundle( locale, bundle );

        setLoaded( true );
        setCmxBundleLoaded( true );
    };

    const handleCompanyChange = ( company ) => {
        routeHistory.push( `/${ company.id }` );
    };

    const goldCompanyId = '00000000-0000-0000-0000-000000000000';


    return (
        <AppError>
            <Route render={ ( route ) => {
                // set the title
                document.title = route && route.match ? route.match.title : 'Home';

                const companyId = route.state?.params?.companyId;

                return (
                    <Bridge
                        auth={ auth }
                        onSignIn={ handleSignIn }
                    >
                        {
                            loaded && (
                                <Layout className="root-layout">
                                    <AppHeader
                                        auth={ auth }
                                        companyId={ companyId }
                                        onCompanyChange={ handleCompanyChange }
                                    />
                                    <Layout>
                                        <Sider>
                                            <NackleMenu
                                                auth={ auth }
                                                cmxBundleLoaded={ cmxBundleLoaded }
                                            />
                                        </Sider>
                                        <Layout className="page-layout">
                                            <Content key={ companyId } className="app-content">
                                                {
                                                    route.match ?
                                                    <>
                                                        { companyId && companyId !== goldCompanyId ?
                                                            React.cloneElement( route.component, { companyId, auth, locale } )
                                                            :
                                                            <Result
                                                                status="403"
                                                                title="403"
                                                                subTitle="Sorry, this page is not accessible for this company. Please pick another company."
                                                            />
                                                        }
                                                    </>
                                                    : 
                                                        <Result
                                                            status="404"
                                                            title="404"
                                                            subTitle="Sorry, the page you visited does not exist. Please select company and try again"
                                                        />
                                                }
                                            </Content>
                                            <AppFooter />
                                        </Layout>
                                    </Layout>
                                </Layout>
                            )
                        }
                    </Bridge>
                );
            } } />
        </AppError>
    );
}

/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware, bundleRoutingMiddleware ] );

/*******************************************************************************
 *  3. Connect Auth to Fetch
 */
applyRequestMiddleware( authRequestMiddleware );